import React from "react";
import { makeStyles } from "@material-ui/core";
import SinglePageContent from "./singlepagecontent";
import PageHead from "../../../pageheading/pageheading";
import { useParams } from "react-router-dom";
import practicecomponentcontext from "../../context";
import { useContext } from "react";
import { useEffect } from "react";

const useStyles = makeStyles((theme) => ({
  singlepagemain: {
    marginBottom: "10rem",
  },
}));

function PreviousYearPaperSinglePageDescription() {
  const classes = useStyles();
  const { id } = useParams();
  const { getPreviousYearPaperDetails, previousyearpaperDetail } = useContext(
    practicecomponentcontext
  );
  const Heading = [
    {
      id: 1,
      // headingsmall: "Explore Your Study",
      // headingmain: "All In One General Studies 2023 ",
      breadcrumb: "Previous Years Papers / Product",
    },
  ];
  
  useEffect(() => {
    getPreviousYearPaperDetails(id);
  }, [id]);

  return (
    <div className={classes.singlepagemain}>
      <PageHead Heading={Heading} previousyearpaperDetail={previousyearpaperDetail} />
      <SinglePageContent previousyearpaperDetail={previousyearpaperDetail} />
    </div>
  );
}
export default PreviousYearPaperSinglePageDescription;
